var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIa2022(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59.29 80.27",
    style: {
      enableBackground: "new 0 0 59.29 80.27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0098CC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.67,62.33h-4.2c-0.37,0-0.58,0.2-0.58,0.57v1.17c0,0.37,0.2,0.57,0.58,0.57h4.2c0.37,0,0.58-0.2,0.58-0.57 V62.9C36.25,62.53,36.05,62.33,35.67,62.33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.94,46.26c0.03-2.39-2.88-4.13-4.09-5.47c-1.52-1.66-3.59-3.86-4.11-5.47c-0.8-2.47-0.05-5.36-0.34-7.86 C42,15.44,33.88,9.03,23.52,6.92l-2.67-0.43c-0.58-0.08-1.17-0.15-1.76-0.2c-2.82-0.25-6.33-0.18-9.24,0.16c0,10.98,0,34.49,0,38.02 c0,5.62,4.11,8.62,8.31,8.62h3.19l0.03,13.71c5.48,6.86,13.54,7.34,15.84,7.34c4.81,0,10.91-0.57,11.64-5.32 c0.33-1.97-1.18-3.6-1-5.47c0.21-2.49,3.55-5.39,0-6.83c3.01-1.28,1.29-3.19,0.83-4.85c-0.48-1.71,0.73-2.7,1.37-2.95 C51,48.33,51.91,48.01,51.94,46.26z M18.03,49.81c-2.71,0-4.9-2.2-4.9-4.91c0-2.71,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9 C22.93,47.62,20.74,49.81,18.03,49.81z M40.67,64.85c0,2.63-1.29,3.95-3.88,3.95h-7.71c-2.45,0-3.68-1.26-3.68-3.81V62.5 c0-2.6,1.24-3.89,3.68-3.89h5.67c0.37,0,0.69,0.09,0.95,0.2v-1.26c0-0.57-0.29-0.86-0.86-0.86h-8.77V52h10.59 c2.68,0,4.03,1.32,4.03,3.95V64.85z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIa2022);
export default __webpack_public_path__ + "static/media/logo_ia_2022.f227b421b4899d9726082fcf3d394ca8.svg";
export { ForwardRef as ReactComponent };